import React from 'react';
import Stack from '@mui/material/Stack';
import { useDispatch, connect } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import CartCounter from '../CartCounter';
import { addToCartData } from '@actions/userActions';
import { useParams } from 'react-router-dom';

function ItemCounter({ keyVal, item: _item, cart, tableNumber }: any) {
    const dispatch = useDispatch();
    const params = useParams();
    const handleValueUpdated = (keyVal: string, val: object, final: number) => {
        if (final === 0) {
            dispatch(addToCartData({ [keyVal]: null }, tableNumber, params?.restaurantId));
        } else {
            dispatch(addToCartData({ [keyVal]: { ...val, selected: final } }, tableNumber, params?.restaurantId));
        }
    }
    // console.log(cart, tableNumber, keyVal);
    const matchKey = cart[tableNumber] && cart[tableNumber][keyVal];
    return (
        <Stack key={keyVal} direction="row" spacing={1}>
            {
                !!matchKey?.selected && <CartCounter initialValue={matchKey.selected} onValueUpdate={(final: any) => handleValueUpdated(keyVal, matchKey, final)} />
            }
            {!matchKey?.selected && <IconButton disableRipple aria-label="add to shopping cart">
                <AddShoppingCartIcon />
            </IconButton>}
        </Stack>
    );
}

const mapStateToProps = (state: any) => {
    const { cart, common } = state
    return { cart: (cart && cart[common?.selectedRestaurant?.docId]) || {}, }
}

export default connect(mapStateToProps)(ItemCounter)
